<template>
    <component :is="el" v-bind="animRoot" class="flex flex-col gap-5">
        <intelligent-inbox-wizard-card :expandable="props.expandable">
            <template v-slot:header>
                <component :is="el" v-bind="animProps">Brand Context</component>
            </template>
            <template v-slot:headerSubtitle>
                <component :is="el" v-bind="animProps"
                    >Tell us about your brand so the AI can understand your business.</component
                >
            </template>
            <template v-slot:content>
                <div class="flex flex-col gap-6">
                    <component :is="el" v-bind="animProps">
                        <vx-label>Brand Name</vx-label>
                        <vx-input
                            :modelValue="props.modelValue.brandName"
                            @update:modelValue="update('brandName', $event)"
                            size="lg"
                        ></vx-input>
                    </component>

                    <component :is="el" v-bind="animProps">
                        <vx-label>Business Description</vx-label>
                        <vx-input
                            :modelValue="props.modelValue.businessDescription"
                            @update:modelValue="update('businessDescription', $event)"
                            size="lg"
                            :rows="3"
                            autoresize
                        ></vx-input>
                    </component>

                    <component :is="el" v-bind="animProps">
                        <vx-label>Engagement Guidelines</vx-label>
                        <vx-input
                            :modelValue="props.modelValue.engagementGuidelines"
                            @update:modelValue="update('engagementGuidelines', $event)"
                            size="lg"
                            :rows="3"
                            autoresize
                        ></vx-input>
                    </component>

                    <component :is="el" v-bind="animProps">
                        <vx-label>Value Proposition Notes</vx-label>
                        <vx-input
                            :modelValue="props.modelValue.valueProposition"
                            @update:modelValue="update('valueProposition', $event)"
                            size="lg"
                            :rows="3"
                            autoresize
                        ></vx-input>
                    </component>
                </div>
            </template>
        </intelligent-inbox-wizard-card>
    </component>
</template>

<script lang="ts" setup>
import { VxInput, VxLabel } from '@voxie/frontend-components';
import IntelligentInboxWizardCard from './IntelligentInboxWizardCard.vue';
import { motion } from 'motion-v';
import { computed } from 'vue';
import type { WizardData } from '../useIntelligentInbox';
import { fadeUpVariants, fieldStagger, quickTransition } from './wizardMotionVariants';

const props = withDefaults(
    defineProps<{
        modelValue: WizardData;
        animated?: boolean;
        expandable?: boolean;
    }>(),
    {
        animated: true,
        expandable: true,
    }
);

const el = computed(() => (props.animated ? motion.div : ('div' as const)));
const animRoot = computed(() =>
    props.animated ? { initial: 'hidden', animate: 'visible', transition: fieldStagger } : {}
);
const animProps = computed(() => (props.animated ? { variants: fadeUpVariants, transition: quickTransition } : {}));

const emit = defineEmits<{
    'update:modelValue': [value: WizardData];
}>();

const update = (key: keyof WizardData, value: string | number): void => {
    emit('update:modelValue', { ...props.modelValue, [key]: String(value) });
};
</script>
